import { WEBSITE_URL } from "./website";

export const SEARCH_RESTAURANTS_AND_ITEMS =
  WEBSITE_URL + "/api/search-restaurants";
export const UPDATE_CART_ITEMS = WEBSITE_URL + "/api/save-cart";
export const GET_SETTINGS_URL = WEBSITE_URL + "/api/get-settings";
export const GET_SUPPORT_INFO_URL = WEBSITE_URL + "/api/get-support-info";
export const SEARCH_LOCATIONS_URL = WEBSITE_URL + "/api/search-location";
export const GET_POPULAR_LOCATIONS_URL =
  WEBSITE_URL + "/api/popular-geo-locations";
export const GET_PROMO_SLIDER_URL = WEBSITE_URL + "/api/promo-slider";
export const GET_HOME_PRODUCTS_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_SHOW_MORE_PRODUCTS_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_PRICE_SORTED_PRODUCTS_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_PRICE_SORTED_SHOW_MORE_PRODUCTS_URL = WEBSITE_URL + "/api/v2/home-products";

/* Category URLs */
export const GET_HOME_CATEGORIES_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_ALL_CATEGORIES_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_CATEGORY_BY_SLUG_URL = WEBSITE_URL + "/api/v2/home-products";
export const SEARCH_CATEGORIES_URL = WEBSITE_URL + "/api/categories/search";
export const GET_CATEGORIES_WITH_PRODUCTS_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_CATEGORY_TREE_URL = WEBSITE_URL + "/api/v2/home-products";
export const GET_CATEGORY_ITEMS_URL = WEBSITE_URL + "/api/v2/category-items";

// Brands (Relax / Relay mode)
export const GET_BRANDS_URL = WEBSITE_URL + "/api/get-brands";
export const GET_BRAND_ITEMS_URL = WEBSITE_URL + "/api/get-brand-items";

export const GET_DELIVERY_RESTAURANTS_URL =
  WEBSITE_URL + "/api/get-delivery-restaurants";
export const GET_SELFPICKUP_RESTAURANTS_URL =
  WEBSITE_URL + "/api/get-selfpickup-restaurants";
export const GET_RESTAURANT_INFO_URL =
  WEBSITE_URL + "/api/get-restaurant-info";
export const GET_RESTAURANT_INFO_BY_ID_URL =
  WEBSITE_URL + "/api/get-restaurant-info-by-id";
export const GET_RESTAURANT_INFO_AND_OPERATIONAL_STATUS_URL =
  WEBSITE_URL + "/api/get-restaurant-info-and-operational-status";
export const GET_RESTAURANT_ITEMS_URL =
  WEBSITE_URL + "/api/get-restaurant-items";
export const APPLY_COUPON_URL = WEBSITE_URL + "/api/apply-coupon";
export const LOGIN_USER_URL = WEBSITE_URL + "/api/login";
export const REGISTER_USER_URL = WEBSITE_URL + "/api/register";
export const GET_PAGES_URL = WEBSITE_URL + "/api/get-pages";
export const GET_SINGLE_PAGE_URL = WEBSITE_URL + "/api/get-single-page";
export const SEARCH_RESTAURANTS_URL =
  WEBSITE_URL + "/api/search-restaurants";
export const GET_ADDRESSES_URL = WEBSITE_URL + "/api/get-addresses";
export const SAVE_ADDRESS_URL = WEBSITE_URL + "/api/save-address";
export const VALIDATE_ADDRESS_URL = WEBSITE_URL + "/api/validate-address";
export const DELETE_ADDRESS_URL = WEBSITE_URL + "/api/delete-address";
export const UPDATE_USER_INFO_URL =
  WEBSITE_URL + "/api/update-user-info";
export const CHANGE_USER_AVATAR_URL = WEBSITE_URL + "/api/change-avatar";
export const CHECK_BAN_URL = WEBSITE_URL + "/api/check-ban";
export const DELETE_USER_ACCOUNT_URL = WEBSITE_URL + "/api/user/delete-account";
export const PLACE_ORDER_URL = WEBSITE_URL + "/api/place-order";
export const SET_DEFAULT_URL = WEBSITE_URL + "/api/set-default-address";
export const GET_ORDERS_URL = WEBSITE_URL + "/api/get-orders";
export const GET_PAYMENT_GATEWAYS_URL =
  WEBSITE_URL + "/api/get-payment-gateways";
export const REMOVE_NOTIFICATION_TOKEN_URL = WEBSITE_URL + "/api/remove-notification-token";
export const NOTIFICATION_TOKEN_URL =
  WEBSITE_URL + "/api/save-notification-token";
export const SEND_OTP_URL = WEBSITE_URL + "/api/send-otp";
export const VERIFY_OTP_URL = WEBSITE_URL + "/api/verify-otp";
export const ACCOUNT_PHONE_SEND_OTP_URL = WEBSITE_URL + "/api/account/phone/send-otp";
export const ACCOUNT_PHONE_VERIFY_OTP_URL = WEBSITE_URL + "/api/account/phone/verify-otp";
export const LOGIN_WITH_OTP_URL = WEBSITE_URL + "/api/login-with-otp";
export const SOCIAL_LOGIN_URL = WEBSITE_URL + "/api/social-login";
export const GENERATE_LOGIN_OTP_URL =
  WEBSITE_URL + "/api/generate-otp-for-login";
export const LOGOUT_URL = WEBSITE_URL + "/api/logout";
export const RAZORPAY_PAYMENT_URL =
  WEBSITE_URL + "/api/payment/process-razor-pay";
export const RAZORPAY_CREATE_ORDER_URL =
  WEBSITE_URL + "/api/payment/razorpay/create-order";
export const RAZORPAY_PROCESS_URL =
  WEBSITE_URL + "/api/payment/razorpay/process";
export const PAYTM_PAYMENT_URL = WEBSITE_URL + "/api/payment/paytm";

export const CHECK_USER_RUNNING_ORDER_URL =
  WEBSITE_URL + "/api/check-running-order";
export const GET_ORDER_CANCEL_URL = WEBSITE_URL + "/api/cancel-order";
export const SUBMIT_RETURN_REQUEST_URL = WEBSITE_URL + "/api/submit-return-request";
export const GET_WALLET_TRANSACTIONS_URL =
  WEBSITE_URL + "/api/get-wallet-transactions";
export const CHECK_RESTAURANT_OPERATION_SERVICE_URL =
  WEBSITE_URL + "/api/check-restaurant-operation-service";
export const GET_SINGLE_ITEM_URL = WEBSITE_URL + "/api/get-single-item";
export const GET_ALL_LANGUAGES_URL =
  WEBSITE_URL + "/api/get-all-languages";
export const GET_SINGLE_LANGUAGE_DATA_URL =
  WEBSITE_URL + "/api/get-single-language";
export const GET_ADDRESS_FROM_COORDINATES =
  WEBSITE_URL + "/api/coordinate-to-address";
export const SEND_PASSWORD_RESET_EMAIL_URL =
  WEBSITE_URL + "/api/send-password-reset-mail";
export const VERIFY_PASSWORD_RESET_OTP_URL =
  WEBSITE_URL + "/api/verify-password-reset-otp";
export const CHANGE_USER_PASSWORD_URL =
  WEBSITE_URL + "/api/change-user-password";
export const GET_RESTAURANTS_CATEGORIES_URL =
  WEBSITE_URL + "/api/get-all-restaurants-categories";
export const GET_FILTERED_RESTAURANTS_URL =
  WEBSITE_URL + "/api/get-filtered-restaurants";
export const GET_RESTAURANTS_SLIDES_URL =
  WEBSITE_URL + "/api/get-restaurant-category-slides";
export const GET_ALERTS_URL =
  WEBSITE_URL + "/api/get-user-notifications";
export const MARK_ALL_NOTIFICATIONS_READ_URL =
  WEBSITE_URL + "/api/mark-all-notifications-read";
export const MARK_ONE_NOTIFICATION_READ_URL =
  WEBSITE_URL + "/api/mark-one-notification-read";
export const CHECK_CART_ITEMS_AVAILABILITY_URL =
  WEBSITE_URL + "/api/check-cart-items-availability";
export const GET_CART_ITEMS_URL = WEBSITE_URL + "/api/get-cart-items";
export const VALIDATE_CART_URL = WEBSITE_URL + "/api/validate-cart";

export const STRIPE_PAYMENT = WEBSITE_URL + "/api/accept-stripe-payment";
export const STRIPE_PAYMENT_CAPTURE =
  WEBSITE_URL + "/api/stripe-redirect-capture";

  

export const PAYMONGO_PAYMENT_URL =
  WEBSITE_URL + "/api/payment/process-paymongo";

export const MERCADOPAGO_PAYMENT_URL =
  WEBSITE_URL + "/api/payment/process-mercado-pago";

export const GET_REVIEWS_OF_STORE_URL =
  WEBSITE_URL + "/api/get-store-reviews";
export const GET_SINGLE_ORDER_TO_BE_RATED =
  WEBSITE_URL + "/api/single-ratable-order";
export const GET_RATABLE_ORDER_DETAILS_URL =
  WEBSITE_URL + "/api/get-ratable-order";
export const ADD_RATING_URL = WEBSITE_URL + "/api/rate-order";
export const GET_ITEM_RATING_SUMMARY_URL =
  WEBSITE_URL + "/api/get-item-rating-summary";
export const ADD_TO_FAVORITE_RESTAURANT_URL =
  WEBSITE_URL + "/api/toggle-favorite";
export const ADD_TO_MAPPED_RESTAURANT_URL =
  WEBSITE_URL + "/api/map-to-restaurant";
export const GET_FAVORITE_RESTAURANTS_URL =
  WEBSITE_URL + "/api/get-favorite-stores";
export const GET_FAVORITE_RESTAURANT_FOR_LOGGED_IN_URL =
  WEBSITE_URL + "/api/get-restaurant-info";
export const SAVE_VAT_NUMBER_URL =
  WEBSITE_URL + "/api/update-tax-number";
export const GET_COUPONS = WEBSITE_URL + "/api/get-coupons";

/* Delivery URLs */
export const LOGIN_DELIVERY_USER_URL =
  WEBSITE_URL + "/api/delivery/login";
export const GENERATE_DELIVERY_LOGIN_OTP_URL =
  WEBSITE_URL + "/api/delivery/generate-otp-for-login";
export const LOGIN_DELIVERY_WITH_OTP_URL =
  WEBSITE_URL + "/api/delivery/login-with-otp";
export const LOGIN_DELIVERY_SOCIAL_URL = WEBSITE_URL + "/api/delivery/social-login";
export const REGISTER_DELIVERY_USER_URL =
  WEBSITE_URL + "/api/delivery/register";
export const GET_DELIVERY_PROFILE_URL =
  WEBSITE_URL + "/api/delivery/get-profile";
export const UPDATE_DELIVERY_PROFILE_URL =
  WEBSITE_URL + "/api/delivery/update-profile";
export const GET_DELIVERY_KYC_URL =
  WEBSITE_URL + "/api/delivery/kyc/get";
export const SUBMIT_DELIVERY_KYC_URL =
  WEBSITE_URL + "/api/delivery/kyc/submit";
export const GET_DELIVERY_BANK_DETAILS_URL =
  WEBSITE_URL + "/api/delivery/bank-details/get";
export const SUBMIT_DELIVERY_BANK_DETAILS_URL =
  WEBSITE_URL + "/api/delivery/bank-details/submit";
export const UPDATE_DELIVERY_USER_INFO_URL =
  WEBSITE_URL + "/api/delivery/update-user-info";
export const GET_DELIVERY_EARNINGS_URL =
  WEBSITE_URL + "/api/delivery/get-earnings";
export const GET_DELIVERY_WALLET_TRANSACTIONS_URL =
  WEBSITE_URL + "/api/delivery/wallet-transactions";
export const DELETE_DELIVERY_ACCOUNT_URL =
  WEBSITE_URL + "/api/delivery/delete-account";
export const GET_DELIVERY_NOTIFICATIONS_URL =
  WEBSITE_URL + "/api/delivery/get-notifications";
export const MARK_ALL_DELIVERY_NOTIFICATIONS_READ_URL =
  WEBSITE_URL + "/api/delivery/mark-all-notifications-read";
export const MARK_ONE_DELIVERY_NOTIFICATION_READ_URL =
  WEBSITE_URL + "/api/delivery/mark-one-notification-read";
export const TOGGLE_DELIVERY_GUY_STATUS_URL =
  WEBSITE_URL + "/api/delivery/toggle-delivery-guy-status";
export const GET_DELIVERY_ORDERS_URL =
  WEBSITE_URL + "/api/delivery/get-delivery-orders";
export const GET_DELIVERY_COMPLETED_ORDERS_URL =
  WEBSITE_URL + "/api/delivery/get-completed-orders";
export const GET_DELIVERY_CANCELLED_ORDERS_URL =
  WEBSITE_URL + "/api/delivery/get-cancelled-orders";
export const GET_SINGLE_DELIVERY_ORDER_URL =
  WEBSITE_URL + "/api/delivery/get-single-delivery-order";
export const SEND_DELIVERY_GUY_GPS_LOCATION_URL =
  WEBSITE_URL + "/api/delivery/set-delivery-guy-gps-location";
export const GET_DELIVERY_GUY_GPS_LOCATION_URL =
  WEBSITE_URL + "/api/delivery/get-delivery-guy-gps-location";
export const GET_ORDER_TRACKING_URL =
  WEBSITE_URL + "/api/user/order-tracking";
export const ACCEPT_TO_DELIVER_URL =
  WEBSITE_URL + "/api/delivery/accept-to-deliver";
export const PICKEDUP_ORDER_URL =
  WEBSITE_URL + "/api/delivery/pickedup-order";
export const DELIVER_ORDER_URL =
  WEBSITE_URL + "/api/delivery/deliver-order";
export const ACCEPT_RETURN_ORDER_URL =
  WEBSITE_URL + "/api/delivery/accept-return-order";
export const CANCEL_ACCEPTED_ORDER_URL =
  WEBSITE_URL + "/api/delivery/cancel-accepted-order";
export const DECLINE_OFFER_URL =
  WEBSITE_URL + "/api/delivery/decline-offer";
export const DELIVERY_SLOTS_URL = WEBSITE_URL + "/api/get-timeslots-api";
export const PORTER_TRACK_ORDER_URL = WEBSITE_URL + "/api/porter/track-order";
export const PORTER_GET_QUOTE_URL = WEBSITE_URL + "/api/porter/get-quote";
export const TRY_SESSION_STATE_URL = WEBSITE_URL + "/api/try-session/state";
export const TRY_SESSION_DECISION_URL = WEBSITE_URL + "/api/try-session/decision";
export const TRY_SESSION_COMPLETE_URL = WEBSITE_URL + "/api/try-session/complete";
export const TRY_SESSION_START_URL = WEBSITE_URL + "/api/try-session/start";
export const DELIVERY_TRY_SESSION_VERIFY_ARRIVAL_URL =
  WEBSITE_URL + "/api/delivery/try-session/verify-arrival";
export const DELIVERY_TRY_SESSION_STATE_URL =
  WEBSITE_URL + "/api/delivery/try-session/state";
export const DELIVERY_TRY_SESSION_UPLOAD_PROOF_URL =
  WEBSITE_URL + "/api/delivery/try-session/upload-arrival-proof";
export const DELIVERY_TRY_SESSION_START_URL =
  WEBSITE_URL + "/api/delivery/try-session/start";
export const DELIVERY_HANDOVER_VERIFY_OTP_URL =
  WEBSITE_URL + "/api/delivery/handover/verify-otp";
export const DELIVERY_PAYMENT_QR_URL = WEBSITE_URL + "/api/delivery/payment/qr";
export const DELIVERY_PAYMENT_STATUS_URL = WEBSITE_URL + "/api/delivery/payment/status";

/* Return request: frontend POSTs to SUBMIT_RETURN_REQUEST_URL; backend sends WhatsApp to admin (config: whatsAppNumber, ultraInstanceId, ultraToken). */
